/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InKeyPublicBase58: core.serialization.ObjectSchema<
    serializers.InKeyPublicBase58.Raw,
    Truvity.InKeyPublicBase58
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InKeyPublicBase58 {
    export interface Raw {
        values: string[];
    }
}
